import { render, staticRenderFns } from "./ImagePreviewModal.vue?vue&type=template&id=42047015&scoped=true&"
import script from "./ImagePreviewModal.vue?vue&type=script&lang=js&"
export * from "./ImagePreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./ImagePreviewModal.vue?vue&type=style&index=0&id=42047015&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42047015",
  null
  
)

export default component.exports